export const SCOUT_SESSION_KEY = "matrixos.scout.session";
export const SCOUT_CREDENTIALS_KEY = "matrixos.scout.credentials";
export const HQ_CREDENTIALS_KEY = "matrixos.hq.credentials";

export const DEFAULT_HQ_USERS = [
  {
    id: "hq-ops-1",
    name: "MatrixOS HQ",
    email: "hq@matrixos.co.za",
    password: "HQ@2026",
    level: "HQ",
    role: "HQ Operator",
    region: "Global",
    status: "Active",
    access: "hq",
  },
];

export const DEFAULT_SCOUTS = [
  {
    id: "alex",
    name: "Alex Johnson",
    email: "alex@matrixos.co.za",
    password: "Scout@2026",
    level: "Level 3",
    role: "Operational Scout",
    region: "Cape Town",
    status: "Active",
    access: "scout",
    candidateState: "Certified Scout",
    certificationStatus: "Active",
    fieldAccess: true,
    academyProgress: { induction: 100, v1: 100, v2: 100, overall: 100 },
  },
];

export function getScoutCredentials() {
  if (typeof window === "undefined") return DEFAULT_SCOUTS;
  try {
    const saved = JSON.parse(window.localStorage.getItem(SCOUT_CREDENTIALS_KEY) || "[]");
    if (Array.isArray(saved) && saved.length) return saved;
  } catch (_) {}
  return DEFAULT_SCOUTS;
}

export function saveScoutCredentials(rows) {
  if (typeof window === "undefined") return;
  const clean = (Array.isArray(rows) ? rows : []).map((row, index) => ({
    id: row.id || `scout-${index + 1}`,
    name: String(row.name || "Operational Scout").trim(),
    email: String(row.email || "").trim().toLowerCase(),
    password: String(row.password || "").trim(),
    level: row.level || "Level 1",
    role: row.role || "Operational Scout",
    region: row.region || "Cape Town",
    status: row.status || "Active",
    access: row.access || "scout",
    candidateState: row.candidateState || "Scout Candidate",
    certificationStatus: row.certificationStatus || "Not Certified",
    fieldAccess: Boolean(row.fieldAccess),
    academyProgress: row.academyProgress || { induction: 0, v1: 0, v2: 0, overall: 0 },
  })).filter((row) => row.email && row.password);
  window.localStorage.setItem(SCOUT_CREDENTIALS_KEY, JSON.stringify(clean.length ? clean : DEFAULT_SCOUTS));
}

export function getScoutSession() {
  if (typeof window === "undefined") return null;
  try {
    const session = JSON.parse(window.sessionStorage.getItem(SCOUT_SESSION_KEY) || "null");
    return session?.email ? session : null;
  } catch (_) {
    return null;
  }
}

export function setScoutSession(scout) {
  if (typeof window === "undefined") return;
  const safe = { ...scout, password: undefined, signedInAt: new Date().toISOString() };
  window.sessionStorage.setItem(SCOUT_SESSION_KEY, JSON.stringify(safe));
}

export function clearScoutSession() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(SCOUT_SESSION_KEY);
}


export function getHQCredentials() {
  if (typeof window === "undefined") return DEFAULT_HQ_USERS;
  try {
    const saved = JSON.parse(window.localStorage.getItem(HQ_CREDENTIALS_KEY) || "[]");
    if (Array.isArray(saved) && saved.length) return saved;
  } catch (_) {}
  return DEFAULT_HQ_USERS;
}

export function saveHQCredentials(rows) {
  if (typeof window === "undefined") return;
  const clean = (Array.isArray(rows) ? rows : []).map((row, index) => ({
    id: row.id || `hq-${index + 1}`,
    name: String(row.name || "MatrixOS HQ").trim(),
    email: String(row.email || "").trim().toLowerCase(),
    password: String(row.password || "").trim(),
    level: row.level || "HQ",
    role: row.role || "HQ Operator",
    region: row.region || "Global",
    status: row.status || "Active",
    access: "hq",
  })).filter((row) => row.email && row.password);
  window.localStorage.setItem(HQ_CREDENTIALS_KEY, JSON.stringify(clean.length ? clean : DEFAULT_HQ_USERS));
}

export const SCOUT_APPLICATIONS_KEY = "matrixos.scout.applications";

export function getScoutApplications() {
  if (typeof window === "undefined") return [];
  try {
    const saved = JSON.parse(window.localStorage.getItem(SCOUT_APPLICATIONS_KEY) || "[]");
    return Array.isArray(saved) ? saved : [];
  } catch (_) {
    return [];
  }
}

export function saveScoutApplication(application) {
  if (typeof window === "undefined") return application;
  const current = getScoutApplications();
  const row = {
    id: application.id || `public-app-${Date.now()}`,
    name: String(application.name || "").trim(),
    email: String(application.email || "").trim().toLowerCase(),
    phone: String(application.phone || "").trim(),
    country: String(application.country || "").trim(),
    region: String(application.region || "").trim(),
    linkedIn: String(application.linkedIn || "").trim(),
    age: String(application.age || "").trim(),
    occupation: String(application.occupation || "").trim(),
    availability: String(application.availability || "Remote / Flexible").trim(),
    motivation: String(application.motivation || "").trim(),
    experience: String(application.experience || "").trim(),
    screeningAnswers: application.screeningAnswers || {},
    stage: application.stage || "New Application",
    score: application.score || 0,
    signal: application.signal || "New recruit",
    practical: application.practical || "Not assigned",
    notes: application.notes || "Public application submitted. Send to screening first.",
    applied: application.applied || "Just now",
    createdAt: application.createdAt || new Date().toISOString(),
  };
  const deduped = current.filter((item) => item.id !== row.id && item.email !== row.email);
  window.localStorage.setItem(SCOUT_APPLICATIONS_KEY, JSON.stringify([row, ...deduped]));
  return row;
}
